<!-- menu start -->
<div [ngClass]="{ open: !isShown }">
  <div class="menu">
    <div class="menu_wrapper">
      <div class="menu_click" (click)="closeMenu()">
        <i></i>
        <i></i>
      </div>
      <span class="menu_lable">Menu</span>
      <figure class="logo">
        <a routerLink="/" (click)="closeMenu()">
          <img src="../../../../assets/image/asd.svg" alt="main_logo" />
        </a>
      </figure>
      <ul class="social_link">
        <li>
          <a target="_blank" href="https://x.com/hardikptm">Tw</a>
        </li>
        <li><a target="_blank" href="https://www.facebook.com/hardik.godhani.1675">Fb</a></li>
        <li>
          <a target="_blank" href="https://www.linkedin.com/in/godhani-hardik/">In</a>
        </li>
        <li><a routerLink="blog-first">Bl</a></li>
        <li><a target="_blank" href="https://www.instagram.com/the_ordinary_hardik/">Ig</a></li>
      </ul>
      <div class="text">
        <p>© 2021 Hardik Godhani. All rights reserved.</p>
      </div>
      <div class="menu_wraper">
        <ul class="nav_main_menu">
          <li (click)="closeMenu()">
            <a routerLink="/"><span>01</span> Home</a>
          </li>
          <li (click)="closeMenu()">
            <a routerLink="about"><span>02</span> About</a>
          </li>
          <li (click)="closeMenu()">
            <a routerLink="services" (click)="selectTab('creative')"><span>03</span> Services</a>
            <ul routerLink="services">
              <li><a (click)="selectTab('creative')">App</a></li>
              <li><a (click)="selectTab('web')">Web</a></li>
              <li><a (click)="selectTab('performance')">Software</a></li>
              <li><a (click)="selectTab('content')">Content</a></li>
            </ul>
          </li>
          <li (click)="closeMenu()">
            <a routerLink="contact" class="get_in_touch"><span>04</span> Get in touch</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- menu end -->
<!-- header start -->
<header>
  <div
    class="top-header w-screen fixed top-0 right-0 flex justify-between flex-wrap items-center"
    [ngClass]="{ dispaly: isActive }"
  >
    <div class="top-header-li">
      <ul [ngClass]="{ left: isActive }">
        <li>
          <a target="_blank" href="https://x.com/hardikptm">
            <p>Tw</p>
            <span><i class="fa-brands fa-twitter"></i></span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://www.facebook.com/hardik.godhani.1675">
            <p>Fb</p>
            <span><i class="fa-brands fa-facebook-f"></i> </span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://www.linkedin.com/in/godhani-hardik/">
            <p>In</p>
            <span><i class="fa-brands fa-linkedin-in"></i></span>
          </a>
        </li>
        <li>
          <a routerLink="blog-first">
            <p>Bl</p>
            <span><i class="fa-solid fa-blog"></i></span>
          </a>
        </li>
        <li>
          <a target="_blank" href="https://www.instagram.com/the_ordinary_hardik/">
            <p>Ig</p>
            <span><i class="fa-brands fa-instagram"></i></span>
          </a>
        </li>
      </ul>
    </div>

    <div class="top-header-menu flex flex-wrap items-center">
      <div class="logo_for_mob">
        <a routerLink="/">
          <img src="../../../../assets/image/asd.svg" alt="main_logo" />
        </a>
      </div>
      <a
        target="_blank"
        href="/assets/Hardik_Godhani _CV.pdf"
        (mouseover)="onMouseOver($event)"
        class="header-button relative text-white text-center overflow-hidden inline-block text-base font-bold cursor-pointer z-10"
      >
        <span class="absolute block -z-10 rounded-full w-0 h-0"></span>Download Resume
      </a>
      <div class="cursor-pointer" (click)="closeMenu()">
        <span class="menu-icon">
          <img src="/assets/icon/menu.svg" alt="menu-icon" class="inline-block" />
        </span>
      </div>
    </div>
  </div>
</header>
<!-- header end -->
